import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthService, SoundService, TenantService } from '@org/shared-services';

@Component({
    selector: 'app-settings',
    imports: [CommonModule],
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  notificationSound: boolean = true;
  assignedToActive: boolean = false;
  isAssignedDisabled: boolean = false;
  assignedToRoleCnt: {count: number, status: boolean } = {count: 0, status: false};
  user!: any;
  partsCoordinatorCount!: number;
  estimatorCount!: number;


  constructor(
    private soundService: SoundService,
    private tenantService: TenantService,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.user = this.authService.currentUserValue;
    this.notificationSound = this.soundService.currentPermission === true;
    this.soundService.permission$
      .pipe(takeUntil(this.destroy$))
      .subscribe((p) => {
        this.notificationSound = p === true;
      });
    this.getEST_PCCounts();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleNotificationSound(): void {
    this.notificationSound = !this.notificationSound;
    this.soundService.setPermission(this.notificationSound);
  }

  /** Tech users do not have `/dashboard` in routes; match post-login redirect. */
  goBack(): void {
    const roles: string[] = this.user?.roles ?? [];
    if (roles.includes('tech')) {
      void this.router.navigateByUrl('/mobile/new-task');
    } else {
      void this.router.navigateByUrl('/dashboard');
    }
  }

  toggleAssignedToStatus(): void {
    this.assignedToActive = !this.assignedToActive;
    this.tenantService.setAssignedToStatus(this.assignedToActive);
    
  }

  getEST_PCCounts(): void {
    this.tenantService.getRolePC_EST_Count().subscribe({
      next: (data: any) => {
        if (data && data.estimators) {
          
          this.assignedToRoleCnt.status = data.hasMultipleUsers;
          this.estimatorCount = data.estimators.count;
          this.partsCoordinatorCount = data.partsCoordinators.count;
          this.assignedToActive = data.assignedTo;
        }
      },
      error: (error) => {
        console.error('Error getting EST_PC_Counts:', error);
      },
    });
  }

  setAssignedToActiveByUser(): void {
    this.assignedToActive = !this.assignedToActive;
    this.tenantService.setAssignedToActiveByUser().subscribe({
      next: (data: any) => { },
      error: (error) => {
        console.error('Error setting AssignedToActiveByUser:', error);
      },
    });
  }

  setAssignedToActiveForTenant(isAssignedActive?: boolean): void {
    this.assignedToActive = !this.assignedToActive;
    this.tenantService.setAssignedToActiveForTenant(this.assignedToActive).subscribe({
      next: (data: any) => {
        this.tenantService.setAssignedToStatus(data.status);
        this.getEST_PCCounts();
        this.snackBar.open(data.message, 'Close', {
          duration: 3000, // Duration in milliseconds
          verticalPosition: 'top', // Position on the screen
          horizontalPosition: 'right',
          panelClass: ['custom-snackbar-container']
        });
      },
      error: (error) => {
        console.error('Error setting Tenant Assigned To Feature:', error);
      },
    });
  }


}
